import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withSnackbar } from 'notistack';
import { Grid } from '@material-ui/core';
import classNames from 'classnames';
import ReactTable from 'react-table';

import { GetAllPersonsAsAdminFromPortal } from '../../../../api/person/GetPersonsFromPortal';
import LoadingSpinner from '../../../../components/LoadingSpinner';
import { withTranslation } from 'react-i18next';
import { PageTitle } from '../../../../components/text/Titles';

class PersonTable extends Component {
  displayName = PersonTable.name;
  constructor(props) {
    super(props);
    this.state = {
      persons: [],
      initialLoad: true,
      loading: true,
      totalPages: null,
      pageSize: 10,
      currentPage: 0,
    }
  }

  componentDidMount() {
    const { persons } = this.state;
    if (persons.length > 0) {
      return;
    }

    this.fetchData();
  }

  getColumns = () => {
    return [
      {
        Header: 'CS ID',
        accessor: 'personCsId',
      },
      {
        Header: 'First Name',
        accessor: 'firstName',
      },
      {
        Header: 'Last Name',
        accessor: 'lastName',
      },
      {
        Header: 'Date of Birth',
        accessor: 'dateOfBirth',
      },
      {
        Header: 'Gender',
        accessor: 'csGenderCode',
      },
      {
        Header: 'FIFA ID',
        accessor: 'personFifaId',
      },
      {
        Header: 'Last Modified',
        accessor: 'lastUpdateDateTime',
      },
    ]
  }

  fetchData = (state, instance) => {
    this.setState({ loading: true });

    const { filtered, page, pageSize, sorted } = state || {};

    GetAllPersonsAsAdminFromPortal(filtered, sorted, pageSize, page)
      .then(res => res.json())
      .then(json => {
        this.setState({
          persons: json.persons.map(p => JSON.parse(p)),
          totalPages: json.totalPages,
          initialLoad: false,
          loading: false,
        });
      })
      .catch(e => {
        this.props.enqueueSnackbar(`Error fetching persons`, { variant: 'error', autoHideDuration: 5500 });
        console.log(e);
      });
  }

  render() {
    const { initialLoad, persons, totalPages, loading, pageSize, filtered } = this.state;
    const { classes, t } = this.props;

    if (initialLoad) {
      return <LoadingSpinner />
    }

    let columns = this.getColumns();

    return (
      <Grid container direction="column" spacing={12}>
        <Grid item>
          <PageTitle text={t('person.personAdministration')} />
        </Grid>
        <Grid item xs={12}>
          <ReactTable
            data={persons}
            defaultFilterMethod={(filter, row) => {
              return String(row[filter.id]).toLowerCase().includes(String(filtered[filter.id].value).toLowerCase())
            }}
            columns={columns}
            className={classNames('-striped -highlight', classes.table)}

            manual
            pages={totalPages}
            loading={loading}
            defaultPageSize={pageSize}
            onFetchData={this.fetchData}
            filterable
          />
        </Grid>
      </Grid>
    )
  }
}


PersonTable.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const styles = theme => ({
  table: {
    fontFamily: theme.typography.fontFamily,
  },
  title: {
    marginBottom: theme.spacing.unit * 2,
  }
});

export default
  withStyles(styles, { withTheme: true })(
    withSnackbar(
      withTranslation()(PersonTable)));
